import React from 'react'
import { safeHTML } from '../../../utils/safeHTML'
import CustomButton from '../../features/customButton/ui/main/CustomButton'
import { useOpen } from '../../../hooks/useOpen'
import Icon from '../../baseComponents/gui/icon/Icon'
import { image } from '../../../utils/data/baseUrl'
import { useTranslation } from '../../../translations'
import { copyrightParams } from '../../../constants/copyright'
import { getStoreLogo } from '../../../utils/getStoreLogo'

const Stub = React.forwardRef(function Stub({ logo, text, button, copyright }, ref) {
  const openLink = useOpen()
  const { t } = useTranslation()
  const storeLogo = getStoreLogo()
  const currentLogo = storeLogo ?? logo
  const toGoldenApple = ({ link }) => openLink(link)

  return (
    <section
      className={'stub'}
      ref={ref}
    >
      <div className={'stub__content'}>
        <header className={'stub__header'}>
          <a
            className={'stub__logo'}
            href={currentLogo.href}
          >
            <Icon name={currentLogo.icon} />
          </a>
        </header>
        <div
          className={'stub__room-wrapper'}
          style={{ alignSelf: 'stretch', flex: 1, position: 'relative' }}
        >
          <img
            className={'stub__image'}
            src={image('stub.png')}
            alt={''}
          />
        </div>
        <div className={'stub__body'}>
          <p className={'stub__text'}>{safeHTML(t(text))}</p>
          <CustomButton
            {...button}
            onClick={toGoldenApple}
          />
          <p className={'stub__copyright'}>{safeHTML(t(copyright, copyrightParams))}</p>
        </div>
      </div>
    </section>
  )
})

export default Stub
Stub.propTypes = {}
